import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialog} from '../../../modules/schedule/models/confirm-dialog.model';
import {AlertDialogType} from '@shared/models';

@Component({
    selector: 'hmt-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    standalone: false
})
export class AlertDialogComponent implements OnInit {
  title: string;
  message: string;
  type: AlertDialogType;
  alertOnly: boolean;
  errorReportData?: ArrayBuffer;
  /** Optional button labels; callers that do not set them keep the existing Yes / No wording. */
  confirmLabel: string;
  cancelLabel: string;

  constructor(
    public dialogAlertRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialog
  ) {
    this.title = data.title;
    this.message = data.message;
    this.type = data.type;
    this.alertOnly = data.alertOnly;
    this.errorReportData = data.errorReportData;
    this.confirmLabel = (data as any).confirmLabel || 'Yes';
    this.cancelLabel = (data as any).cancelLabel || 'No';
  }

  @Output() closeClick = new EventEmitter();
  ngOnInit(): void {
  }

  get hasErrorReportFile(): boolean {
    return this.errorReportData != null && this.errorReportData.byteLength > 0;
  }

  onConfirm(): void {
    this.dialogAlertRef.close(true);
  }

  onDismiss(): void {
    this.dialogAlertRef.close(false);
  }

  onOk() {
    this.dialogAlertRef.close(false);
  }

  onDownloadErrorFile(): void {
    if (!this.errorReportData) return;
    const blob = new Blob([this.errorReportData], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const now = new Date();
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'Order File Error Report ' + now.toLocaleDateString() + '.xlsx';
    link.click();
    window.URL.revokeObjectURL(link.href);
    link.remove();
  }
}


